export default __webpack_public_path__ + "static/media/Webinar_George.e1cd4b87.jpg";